module.exports = __webpack_public_path__ + "src/components/PlaceMap/map-pin.png?7602a384";


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaceMap/map-pin.png
// module id = 3370
// module chunks = 8